<!--
 * @Author: dong_fs
 * @Date: 2022-12-14 16:38:28
 * @LastEditTime: 2022-12-17 14:24:46
 * @Description: 修改属性
-->

<template>
    <div class="modifyAttributes">
        <el-dialog
            title="修改"
            :visible.sync="dialogVisible"
            width="500px"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            append-to-body
            :before-close="handleClose"
            top="8vh"
        >
            <div class="modifyAttributes-content">
                <div class="fw-text redFont">
                    <p>违禁词：{{ attributefw }}</p>
                    <p class="mt10">错误信息：{{ attributeName }}属性值存在违禁词</p>
                </div>
                <div class="attribute h450 mt20">
                    <Attribute ref="attribute" :is-show-custom="true" />
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="dialogVisible = false">取消</el-button>
                <el-button size="small" type="primary" @click="confirm">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import Attribute from './common/attribute/attribute.vue';
export default {
    //import引入的组件需要注入到对象中才能使用
    components: { Attribute },
    data() {
        return {
            dialogVisible: false,
            attributefw: '',
            attributeName: [],
        };
    },
    //监控data中的数据变化
    watch: {},
    //监听属性 类似于data概念
    computed: {},
    methods: {
        show(data) {
            this.dialogVisible = true;
            const attributeFwText = data.attributeFwText.split('|');
            this.attributeName = data.attributeName.join(',');
            let arr = [];
            for (let j = 0, len1 = attributeFwText.length; j < len1; j++) {
                const item = attributeFwText[j];
                if (item.split(')')[1] === '') {
                    // "爆款(1)" num = 1,word = "爆款"
                    const start = item.indexOf('(');
                    const word = item.substring(0, start);
                    arr.push(word);
                } else if (item) {
                    this.attributeFwOne.push(item);
                    arr.push(item);
                }
            }
            this.attributefw = arr.join(',');
            this.callBack = data.callBack;
            setTimeout(() => {
                this.$refs.attribute.initModel({
                    ClassifyId: data.productionInfo.CategoryId,
                    initAttrVals: data.productionInfo.Attributes,
                });
            }, 10);
        },

        handleClose() {
            this.dialogVisible = false;
        },

        confirm() {
            const data = this.$refs.attribute.getData();
            this.callBack && this.callBack(data);
            this.dialogVisible = false;
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {},
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {},
};
</script>

<style lang="scss" scoped>
//@import url()

.modifyAttributes-content {
    .attribute {
        overflow: auto !important;
    }
}
</style>
